// brigadeService.js
import { apiClient, API_ENDPOINTS } from './api';

export const brigadeService = {
  // Получить все бригады с автоматической пагинацией
  async getAll(pageSize = 100) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BRIGADES);
      const data = response.data || response;
      
      // Унифицируем ответ
      let items = [];
      if (Array.isArray(data)) {
        items = data;
      } else if (data && data.brigades && Array.isArray(data.brigades)) {
        items = data.brigades;
      } else if (data && data.data && Array.isArray(data.data)) {
        items = data.data;
      } else {
        items = data;
      }
      
      // Если есть пагинация и это не все данные
      if (data && data.meta && data.meta.total > items.length) {
        return await this.getAllWithPagination(data, pageSize);
      }
      
      return items;
    } catch (error) {
      console.error('Ошибка загрузки бригад:', error);
      throw error;
    }
  },

  // Вспомогательный метод для загрузки всех страниц
  async getAllWithPagination(firstResponse, pageSize = 100) {
    const firstData = firstResponse.data || firstResponse;
    let items = [];
    
    if (Array.isArray(firstData)) {
      items = firstData;
    } else if (firstData && firstData.brigades && Array.isArray(firstData.brigades)) {
      items = firstData.brigades;
    } else if (firstData && firstData.data && Array.isArray(firstData.data)) {
      items = firstData.data;
    }
    
    const total = firstData.meta?.total || 0;
    const perPage = firstData.meta?.per_page || pageSize;
    const totalPages = Math.ceil(total / perPage);
    
    if (totalPages <= 1) {
      return items;
    }
    
    // Параллельная загрузка остальных страниц
    const remainingPages = [];
    for (let page = 2; page <= totalPages; page++) {
      remainingPages.push(
        apiClient.get(`${API_ENDPOINTS.BRIGADES}?page=${page}&per_page=${perPage}`)
      );
    }
    
    const remainingResponses = await Promise.all(remainingPages);
    const allItems = [...items];
    
    for (const response of remainingResponses) {
      const responseData = response.data || response;
      let pageItems = [];
      
      if (Array.isArray(responseData)) {
        pageItems = responseData;
      } else if (responseData && responseData.brigades && Array.isArray(responseData.brigades)) {
        pageItems = responseData.brigades;
      } else if (responseData && responseData.data && Array.isArray(responseData.data)) {
        pageItems = responseData.data;
      }
      
      if (Array.isArray(pageItems)) {
        allItems.push(...pageItems);
      }
    }
    
    console.log(`Загружено ${allItems.length} из ${total} бригад`);
    return allItems;
  },

  // Получить бригаду по ID
  async getById(id) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BRIGADE(id));
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки бригады ${id}:`, error);
      throw error;
    }
  },

  // Создать бригаду
  async create(data) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.BRIGADES, data);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка создания бригады:', error);
      throw error;
    }
  },

  // Обновить бригаду
  async update(id, data) {
    try {
      const response = await apiClient.put(API_ENDPOINTS.BRIGADE(id), data);
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка обновления бригады ${id}:`, error);
      throw error;
    }
  },

  // Удалить бригаду
  async delete(id) {
    try {
      await apiClient.delete(API_ENDPOINTS.BRIGADE(id));
      return true;
    } catch (error) {
      console.error(`Ошибка удаления бригады ${id}:`, error);
      throw error;
    }
  },

  // Получить участников бригады
  async getMembers(id) {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BRIGADE_MEMBERS(id));
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка загрузки участников бригады ${id}:`, error);
      throw error;
    }
  },

  // Добавить участника в бригаду
  async addMember(brigadeId, employeeId) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.BRIGADE_MEMBERS(brigadeId), { employee_id: employeeId });
      return response.data || response;
    } catch (error) {
      console.error(`Ошибка добавления участника в бригаду ${brigadeId}:`, error);
      throw error;
    }
  },

  // Удалить участника из бригады
  async removeMember(brigadeId, employeeId) {
    try {
      await apiClient.delete(API_ENDPOINTS.BRIGADE_MEMBER(brigadeId, employeeId));
      return true;
    } catch (error) {
      console.error(`Ошибка удаления участника из бригады ${brigadeId}:`, error);
      throw error;
    }
  },

  // Получить статистику по бригадам
  async getStatistics() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.BRIGADES_STATISTICS);
      return response.data || response;
    } catch (error) {
      console.error('Ошибка загрузки статистики бригад:', error);
      throw error;
    }
  }
};